import { render, staticRenderFns } from "./dictionary-child.vue?vue&type=template&id=ba575408"
import script from "./dictionary-child.vue?vue&type=script&lang=ts"
export * from "./dictionary-child.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports